import React, { createContext, useContext, useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import { message } from 'antd';
import { Navigate, useNavigate } from 'react-router-dom';
import useAutoLogout from '../hooks/useAutoLogout';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem('token') || '');
  const [user, setUser] = useState(null);
  const navigate = useNavigate();


  // Decodifica y valida expiración
  useEffect(() => {
    if (!token) return;

    try {
      const decoded = jwtDecode(token);
      const now = Date.now() / 1000;

      if (!decoded.exp || decoded.exp < now) {
        console.warn("Token expirado o sin campo exp");
        logout();
      } else {
        setUser({ id: decoded.user_id, name: decoded.name, profile_picture: decoded.profile_picture });
      }
    } catch (err) {
      console.error("Error al decodificar token:", err);
      logout();
    }
  }, [token]);



  const login = (newToken) => {
    localStorage.setItem('token', newToken);
    setToken(newToken);
  };

  const logout = () => {
    localStorage.clear();
    setToken('');
    setUser(null);
    message.info('Sesión cerrada');
    navigate('/'); // Redirigir a la página de inicio

  };

  useAutoLogout(logout); // cerrar por inactividad

  return (
    <AuthContext.Provider value={{ token, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);